import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
// import OneSignal from 'react-onesignal'; // Not needed - using native SDK from index.html
import './App.css';

// Version Checker - Fuerza actualización cuando hay nueva versión
import { VersionProvider, useVersion } from './components/VersionChecker';
import ChatWidgetLoader from './components/ChatWidgetLoader';
import { VideoCallProvider } from './contexts/VideoCallContext';

// Banner de actualización que aparece en la parte superior
const UpdateBanner = () => {
  const { updateAvailable, serverVersion, applyUpdate } = useVersion();
  
  if (!updateAvailable) return null;
  
  const formatVersion = (version) => {
    if (!version || version.length < 8) return version;
    try {
      const day = version.substring(6, 8);
      const month = version.substring(4, 6);
      const hour = version.substring(8, 10) || '00';
      const min = version.substring(10, 12) || '00';
      return `${day}/${month} ${hour}:${min}`;
    } catch {
      return version;
    }
  };
  
  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2 px-4 z-[9999] shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-yellow-400"></span>
          </span>
          <span className="text-sm font-medium">
            ¡Nueva versión disponible! ({formatVersion(serverVersion)})
          </span>
        </div>
        <button
          onClick={applyUpdate}
          className="bg-white text-blue-600 px-4 py-1 rounded-full text-sm font-bold hover:bg-blue-50 transition-colors shadow"
        >
          Actualizar Ahora
        </button>
      </div>
    </div>
  );
};

// Components
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PerfilCompleto from './components/PerfilCompleto';
import Layout from './components/Layout';
import Clases from './components/Clases';
import CentroEvaluaciones from './components/CentroEvaluaciones';
import VideosClases from './components/VideosClases';
import AsistenciasClases from './components/AsistenciasClases';
import MarcarAsistenciaQR from './components/MarcarAsistenciaQR';
import TareasKanban from './components/TareasKanban';
import PruebasExamenes from './components/PruebasExamenes';
import Calificaciones from './components/Calificaciones';
import PanelControlAcademico from './components/PanelControlAcademico';
import ScanPresencia from './components/ScanPresencia';
import RedOracionIBA from './components/RedOracionIBA';
import ReunionesProfesor from './components/ReunionesProfesor';
import GestionReunionesProfesor from './components/GestionReunionesProfesor';
import Biblia from './components/Biblia';
import BibliaAudio from './components/BibliaAudio';
import BibliaPlanes from './components/BibliaPlanes';
import BibliaYouVersion from './components/BibliaYouVersion';
import PensamientosBiblicos from './components/PensamientosBiblicos';
import YouVersionOAuthCallback from './components/YouVersionOAuthCallback';
import { BibleRefViewerProvider } from './components/BibleRefViewer';
import StreamChatComponent from './components/StreamChatComponent';
import RedSocialIBA from './components/RedSocialIBA';
import MisForosClases from './components/MisForosClases';
import ForoClaseFeed from './components/ForoClaseFeed';
import SalaDocente from './components/SalaDocente';
import ComiteEvangelistico from './components/ComiteEvangelistico';
import GestionForosClases from './components/GestionForosClases';
// import Cliq from './components/Cliq'; // DESHABILITADO - Ya no se usa Zoho Cliq
// import GestionCliq from './components/GestionCliq'; // DESHABILITADO - Ya no se usa Zoho Cliq
import MisDenarios from './components/MisDenarios';
import Noticias from './components/Noticias';
import Calendario from './components/Calendario';
import Eventos from './components/Eventos';
import ActividadesExtracurriculares from './components/ActividadesExtracurriculares';
import MarcarAsistenciaEventoQR from './components/MarcarAsistenciaEventoQR';
import MarcarAsistenciaActividad from './components/MarcarAsistenciaActividad';
import Usuarios from './components/Usuarios';
import Formularios from './components/Formularios';
import GestionarFormulario from './components/GestionarFormulario';
import ResponderFormulario from './components/ResponderFormulario';
import RespuestasFormulario from './components/RespuestasFormulario';
import CalificarRespuesta from './components/CalificarRespuesta';
import ResultadosFormulario from './components/ResultadosFormulario';
import MaterialesClase from './components/MaterialesClase';
import MaterialesClases from './components/MaterialesClases';
import SemestresWidget from './components/SemestresWidget';
import Perfil from './components/Perfil';
import RenovacionPendiente from './components/RenovacionPendiente';
import VideosClase from './components/VideosClase';
import RegistracionesSemestre from './components/RegistracionesSemestre';
import ProcesoRegistro from './components/ProcesoRegistro';
import MisInvoices from './components/MisInvoices';
import GestionPrecios from './components/GestionPrecios';
import AdminRegistraciones from './components/AdminRegistraciones';
import AdminGenesisLibros from './components/AdminGenesisLibros';
import GestionEstudiantesNuevos from './components/GestionEstudiantesNuevos';
import GestionAdministradores from './components/GestionAdministradores';
import PagosOnline from './components/PagosOnline';
import AdminPagos from './components/AdminPagos';
import PipelineRegistro from './components/PipelineRegistro';
import PagosEstudiantes from './components/PagosEstudiantes';
import GestionNotificaciones from './components/GestionNotificaciones';
import LandingPage from './components/LandingPage';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import FormularioPendiente from './components/FormularioPendiente';
import EstudiantesPendientes from './components/EstudiantesPendientes';
import FormularioConfig from './components/FormularioConfig';
import GoogleDriveCallback from './components/GoogleDriveCallback';
import EstadoSistema from './components/EstadoSistema';
import GestionUsuarios from './components/GestionUsuarios';
import ActividadUsuarios from './components/ActividadUsuarios';
import GestionInactividadPage from './components/GestionInactividadPage';
import VerificarDiploma from './components/VerificarDiploma';
import GestionCompromisosPago from './components/GestionCompromisosPago';
import GestionSemestres from './components/GestionSemestres';
import GestionBackups from './components/GestionBackupsFull';
import GestionBienvenida from './components/GestionBienvenida';
import GestionSeccionesLanding from './components/GestionSeccionesLanding';
import GestionProfesores from './components/GestionProfesores';
import GestionRedesSociales from './components/GestionRedesSociales';
import GestionReferidos from './components/GestionReferidos';
import GestionConsultasVisitantes from './components/GestionConsultasVisitantes';
import ConfigFormularioRegistraciones from './components/ConfigFormularioRegistraciones';
import ConfigEmailsRespuesta from './components/ConfigEmailsRespuesta';
import ConfigAnuncioLateral from './components/ConfigAnuncioLateral';
import ConfigAnuncioDashboard from './components/ConfigAnuncioDashboard';
import MisCuotas from './components/MisCuotas';
import AdminPlanesCuotas from './components/AdminPlanesCuotas';
import ConfigBannerFlotante from './components/ConfigBannerFlotante';
import ConfigBannerExtracurricular from './components/ConfigBannerExtracurricular';
import ConfigBannerSemestre from './components/ConfigBannerSemestre';
import Manuales from './components/Manuales';
import GestionArchivos from './components/GestionArchivos';
import GestionPlanesBiblia from './components/GestionPlanesBiblia';
import Marketing from './components/Marketing';
import ErrorBoundary from './components/ErrorBoundary';
import FormulariosIndependientes from './components/FormulariosIndependientes';
import GestionSMS from './components/GestionSMS';
import GestionCartaBienvenida from './components/GestionCartaBienvenida';
import ConfiguracionInvoices from './components/ConfiguracionInvoices';
import ConfigChatWidgets from './components/ConfigChatWidgets';
import ConfigWebhooks from './components/ConfigWebhooks';
import GestionInvoices from './components/GestionInvoices';
// import GestionGenesis from './components/GestionGenesis'; // DESHABILITADO - No se usará Genesi AI
import GestionNotificacionesAutomaticas from './components/GestionNotificacionesAutomaticas';
import GestionNotificacionesPush from './components/GestionNotificacionesPush';
import HistorialNotificaciones from './components/HistorialNotificaciones';
import GestionZoomClases from './components/GestionZoomClases';
import EnviarNotificacionPush from './components/EnviarNotificacionPush';
import AdminEnviarEmails from './components/AdminEnviarEmails';

import GaleriaFotos from './components/GaleriaFotos';
import GestionScheduler from './components/GestionScheduler';
import HistorialCambios from './pages/Admin/HistorialCambios';
import AIAssistantButton from './components/AIAssistantButton';
import { Toaster } from './components/ui/sonner';
import GestionFormularioBecas from './components/GestionFormularioBecas';
import SolicitudBeca from './components/SolicitudBeca';
import SolicitudesBecas from './components/SolicitudesBecas';
import GestionHorasProfesor from './components/GestionHorasProfesor';
import CumplimientoPlanEstudios from './components/CumplimientoPlanEstudios';
import NotificationPermissionModal from './components/NotificationPermissionModal';
import GestionCanjesDenarios from './components/GestionCanjesDenarios';
import CanjesDenarios from './components/CanjesDenarios';
import CanjesAcademicos from './components/CanjesAcademicos';
import CanjesMateriales from './components/CanjesMateriales';
import CanjesCategoria from './components/CanjesCategoria';
import GestionDenarios from './components/GestionDenarios';
import FormularioPublico from './components/FormularioPublico';
import SolicitarVideollamada from './components/SolicitarVideollamada';
// Genesis AI - RAG-based AI Assistant
import GenesisAI from './components/GenesisAI';
// Asociación Graduados IBA
import GraduadosDirectorio from './components/GraduadosDirectorio';
import GraduadosGrabaciones from './components/GraduadosGrabaciones';
import GraduadosDevocionales from './components/GraduadosDevocionales';
// Panel de Avance de Estudiantes (para profesores y admin)
import AvanceEstudiantes from './components/AvanceEstudiantes';
import DetalleEstudiante from './components/DetalleEstudiante';
import SoporteTecnico from './components/SoporteTecnico';
import Citas from './components/Citas';
// Zoom SDK Test (página de prueba aislada - solo admin)
import ZoomSDKTest from './components/ZoomSDKTest';
import ZoomSDKSandbox from './components/ZoomSDKSandbox';
import ClaseEnVivo from './components/ClaseEnVivo';
import ClaseProfesorZoom from './components/ClaseProfesorZoom';
// ZoomEmbedded - Carga vía CDN (no usa npm @zoom/meetingsdk para evitar OOM en build)
import ZoomEmbedded from './components/ZoomEmbedded';

// Configuración automática de la API - DETECCIÓN INTELIGENTE DE ENTORNO
const getApiUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // CRÍTICO: Siempre usar /api como prefijo para que Kubernetes ingress redirija al backend (puerto 8001)
  // Kubernetes rules: /api/* → backend:8001, /* → frontend:3000
  
  let detectedUrl = window.location.origin;
  
  // Log para debugging (visible en consola del navegador)
  console.log('🔍 URL Detection:', {
    hostname,
    protocol,
    detectedUrl,
    apiUrl: detectedUrl, // Backend accesible en mismo dominio via /api prefix
    envUrl: process.env.REACT_APP_BACKEND_URL || 'not set'
  });
  
  // IMPORTANTE: El backend es accesible en el mismo dominio con prefijo /api
  // Kubernetes ingress maneja el routing internamente
  return detectedUrl;
};

const BACKEND_URL = getApiUrl();
const API = `${BACKEND_URL}/api`;

// Log final de configuración
console.log('✅ API Configuration:', {
  BACKEND_URL,
  API,
  timestamp: new Date().toISOString()
});

// Axios interceptor for auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Import outage service for tracking system errors
import { recordOutage } from './services/outageService';

// Axios response interceptor - RESILIENTE a caídas temporales del servidor
let isRedirecting = false;
let retryingAuth = false;

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    
    // Track 5XX errors
    if (status >= 500 && status < 600) {
      recordOutage({
        status: status,
        url: requestUrl,
        method: error.config?.method?.toUpperCase() || 'GET',
        message: error.message || `Error ${status}`,
        userEmail: localStorage.getItem('userEmail')
      });
    }
    
    // Track network errors
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
      recordOutage({
        status: 'NETWORK_ERROR',
        url: requestUrl,
        method: error.config?.method?.toUpperCase() || 'GET',
        message: error.message || 'Error de red',
        userEmail: localStorage.getItem('userEmail')
      });
    }

    // 502/504 - Servidor caído temporalmente: NO cerrar sesión, solo avisar
    if (status === 502 || status === 504 || error.code === 'ERR_NETWORK') {
      console.warn(`[IBA] Error temporal del servidor (${status || 'NETWORK'}). No se cierra sesión.`);
      // No hacer reload ni eliminar token - el servidor se recuperará
      return Promise.reject(error);
    }
    
    // 401 - Token inválido: verificar antes de cerrar sesión
    if (status === 401 && !isRedirecting && !retryingAuth) {
      const token = localStorage.getItem('token');
      
      // Si no hay token, no hacer nada (ya está deslogueado)
      if (!token) return Promise.reject(error);
      
      // Si el 401 viene del endpoint de auth/me, es un token realmente inválido
      if (requestUrl.includes('/auth/me') || requestUrl.includes('/auth/login')) {
        isRedirecting = true;
        const currentPath = window.location.pathname;
        if (currentPath && currentPath !== '/app' && currentPath !== '/') {
          localStorage.setItem('intended_route', currentPath);
        }
        localStorage.removeItem('token');
        setTimeout(() => {
          window.location.reload();
          isRedirecting = false;
        }, 300);
      } else {
        // 401 en otro endpoint: verificar si el token sigue siendo válido
        retryingAuth = true;
        try {
          await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          // Token sigue válido - fue un error puntual, no cerrar sesión
          console.log('[IBA] Token sigue válido, error 401 fue puntual');
        } catch (retryErr) {
          // Token realmente inválido - ahora sí cerrar sesión
          if (retryErr.response?.status === 401) {
            isRedirecting = true;
            const currentPath = window.location.pathname;
            if (currentPath && currentPath !== '/app' && currentPath !== '/') {
              localStorage.setItem('intended_route', currentPath);
            }
            localStorage.removeItem('token');
            setTimeout(() => {
              window.location.reload();
              isRedirecting = false;
            }, 300);
          }
          // Si el retry falla por 502/504/network, no cerrar sesión
        } finally {
          retryingAuth = false;
        }
      }
    }
    return Promise.reject(error);
  }
);

// Auth Context
export const AuthContext = React.createContext();

// Component to handle route restoration after 401 reload
function RouteRestorer({ user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [hasRestored, setHasRestored] = React.useState(false);
  
  useEffect(() => {
    // Only restore route once if user is authenticated and we're on the base /app path
    if (user && location.pathname === '/app' && !hasRestored) {
      const intendedRoute = localStorage.getItem('intended_route');
      if (intendedRoute && intendedRoute !== '/app' && intendedRoute !== '/') {
        console.log('🔄 Restoring route after auth:', intendedRoute);
        localStorage.removeItem('intended_route');
        setHasRestored(true);
        navigate(intendedRoute, { replace: true });
      }
    }
  }, [user, navigate, location, hasRestored]);
  
  return null; // This component doesn't render anything
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);
  const [isSupportSession, setIsSupportSession] = useState(() => {
    return localStorage.getItem('is_support_session') === 'true';
  });

  // Initial auth check - runs only once on mount
  useEffect(() => {
    // Detectar retorno desde Zoom (celular/tablet)
    const returnUrl = localStorage.getItem('ibaconnect_return');
    if (returnUrl) {
      localStorage.removeItem('ibaconnect_return');
      console.log('🔄 Retorno desde Zoom, redirigiendo a:', returnUrl);
      // Pequeño delay para que la app se inicialice
      setTimeout(() => {
        const url = new URL(returnUrl);
        window.location.href = url.pathname + url.search;
      }, 500);
    }

    const token = localStorage.getItem('token');
    if (token) {
      checkAuth();
    } else {
      setLoading(false);
      setAuthChecked(true);
    }
  }, []); // Empty dependency array - runs only once

  // Initialize OneSignal Push Notifications
  // The SDK is initialized in index.html <head> section
  useEffect(() => {
    // Debug log para verificar el estado
    console.log('🔍 OneSignal useEffect - user:', user?.email, 'force_onesignal_prompt:', user?.force_onesignal_prompt);

    // ⚠️ PROTECCIÓN CRÍTICA: si esta sesión fue iniciada con la CLAVE MAESTRA
    // (admin entrando como un estudiante para ayudarlo), NO debemos registrar
    // al dispositivo del admin con el external_id/email del estudiante en
    // OneSignal — eso "secuestra" las notificaciones del estudiante real
    // (las recibe el admin, y el estudiante real deja de recibirlas).
    if (localStorage.getItem('is_support_session') === 'true') {
      console.warn('⛔ Sesión de soporte detectada — saltando registro en OneSignal para no contaminar el dispositivo del estudiante real.');
      // Además, hacemos OneSignal.logout() para limpiar cualquier asociación
      // previa que pudiera quedar del admin (por si esto pasó antes del fix).
      if (window.OneSignal) {
        window.OneSignalDeferred = window.OneSignalDeferred || [];
        window.OneSignalDeferred.push(async function(OneSignal) {
          try {
            await OneSignal.logout();
            console.log('🧹 OneSignal.logout() ejecutado en sesión de soporte');
          } catch (e) {
            console.warn('OneSignal.logout error:', e?.message || e);
          }
        });
      }
      return;
    }

    // El manejo de force_onesignal_prompt ahora está en Layout.js con un modal visual
    // Aquí solo manejamos la sincronización del subscription_id

    // Set external user ID and tags when user logs in
    if (user && user.id && window.OneSignal) {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(async function(OneSignal) {
        try {
          // Verificar estado de suscripción push
          const isSubscribed = await OneSignal.User?.PushSubscription?.optedIn;
          console.log('🔔 OneSignal isSubscribed:', isSubscribed);
          
          // SIEMPRE hacer login para registrar el external_id del usuario en OneSignal
          // Esto es necesario para que include_aliases funcione en notificaciones
          try {
            await OneSignal.login(user.id);
            console.log('✅ OneSignal user ID set (login):', user.id);
          } catch (loginErr) {
            console.log('⚠️ OneSignal login error (puede ignorarse):', loginErr.message);
          }
          
          // Agregar email como canal de contacto (siempre intentar)
          if (user.email) {
            try {
              await OneSignal.User.addEmail(user.email);
              console.log('✅ OneSignal email agregado:', user.email);
            } catch (emailError) {
              console.log('⚠️ OneSignal email error (puede ya existir):', emailError.message);
            }
          }
          
          // Add tags for segmentation (CRITICAL for role-based notifications)
          const userTags = {
            role: user.rol || '',
            email: user.email || '',
            nombre: user.nombre || '',
            apellido: user.apellido || '',
            nombre_completo: `${user.nombre || ''} ${user.apellido || ''}`.trim(),
            user_id: user.id || '',
            activo: user.activo ? 'true' : 'false',
            es_graduado: user.es_graduado ? 'true' : 'false'
          };
          
          try {
            await OneSignal.User.addTags(userTags);
            console.log('✅ OneSignal user tags set:', userTags);
          } catch (tagsErr) {
            console.log('⚠️ OneSignal tags error:', tagsErr.message);
          }
          
        } catch (error) {
          console.error('❌ OneSignal user setup error:', error);
        }
      });
    }
  }, [user]);

  // ============================================
  // ONESIGNAL SUBSCRIPTION SYNC - Robust Solution
  // ============================================
  useEffect(() => {
    if (!user || !user.id) return;
    
    console.log('🔔 Iniciando sincronización OneSignal para:', user.email);
    
    // Función para guardar el subscription_id en la BD
    const saveSubscriptionId = async (subscriptionId) => {
      if (!subscriptionId) {
        console.log('⚠️ No hay subscription_id para guardar');
        return false;
      }
      
      const token = localStorage.getItem('token');
      if (!token) {
        console.log('⚠️ No hay token de autenticación');
        return false;
      }
      
      console.log('📤 Enviando subscription_id al servidor:', subscriptionId.substring(0, 20) + '...');
      
      try {
        const response = await fetch(`${API}/usuarios/update-onesignal-subscription`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ subscription_id: subscriptionId })
        });
        
        if (response.ok) {
          const result = await response.json();
          console.log('✅ OneSignal subscription_id GUARDADO:', result);
          localStorage.setItem('onesignal_synced', Date.now().toString());
          return true;
        } else {
          const errorText = await response.text();
          console.error('❌ Error del servidor:', response.status, errorText);
        }
      } catch (error) {
        console.error('❌ Error de red guardando subscription_id:', error);
      }
      return false;
    };
    
    // Función para sincronizar todos los datos del usuario con OneSignal
    const syncUserDataToOneSignal = async (OneSignal) => {
      try {
        console.log('📤 Sincronizando datos completos del usuario con OneSignal...');
        
        // Login con el ID del usuario
        try {
          await OneSignal.login(user.id);
          console.log('✅ OneSignal login completado:', user.id);
        } catch (loginError) {
          console.log('⚠️ OneSignal login error (usuario puede ya estar logueado):', loginError.message || loginError);
        }
        
        // Agregar email (envuelto en try-catch separado)
        try {
          await OneSignal.User.addEmail(user.email);
          console.log('✅ OneSignal email agregado:', user.email);
        } catch (emailError) {
          console.log('⚠️ OneSignal addEmail error (puede ya existir):', emailError.message || emailError);
        }
        
        // Preparar tags del usuario
        const userTags = {
          email: user.email,
          name: user.nombre || '',
          role: user.rol || '',
          nombre: user.nombre || '',
          apellido: user.apellido || '',
          nombre_completo: `${user.nombre || ''} ${user.apellido || ''}`.trim(),
          user_id: user.id,
          activo: user.activo ? 'true' : 'false',
          es_graduado: user.es_graduado ? 'true' : 'false'
        };
        
        // Agregar tags (envuelto en try-catch para manejar 409 Conflict)
        try {
          await OneSignal.User.addTags(userTags);
          console.log('✅ OneSignal tags sincronizados:', userTags);
        } catch (tagError) {
          // Error 409 Conflict es común y no es crítico
          if (tagError.message?.includes('409') || tagError.status === 409) {
            console.log('⚠️ OneSignal tags conflict (datos ya existen), ignorando...');
          } else {
            console.log('⚠️ OneSignal tags error:', tagError.message || tagError);
          }
        }
        
      } catch (error) {
        console.error('❌ Error sincronizando datos con OneSignal:', error);
      }
    };
    
    // Función principal de sincronización usando OneSignalDeferred
    const syncWithOneSignal = () => {
      if (!window.OneSignal && !window.OneSignalDeferred) {
        console.log('⚠️ OneSignal no está disponible en este navegador/dispositivo');
        return;
      }
      
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(async function(OneSignal) {
        try {
          console.log('🔔 OneSignal SDK listo, obteniendo subscription...');
          
          // Función para obtener el subscription_id con reintentos
          const getSubscriptionIdWithRetry = async (maxRetries = 5, delayMs = 2000) => {
            for (let i = 0; i < maxRetries; i++) {
              const subscription = OneSignal.User?.PushSubscription;
              const subscriptionId = subscription?.id;
              const optedIn = subscription?.optedIn;
              
              console.log(`📱 Intento ${i + 1}/${maxRetries} - Subscription ID: ${subscriptionId || 'undefined'}, Opted In: ${optedIn}`);
              
              if (subscriptionId) {
                return subscriptionId;
              }
              
              // Si está opted in pero no hay ID, esperar y reintentar
              if (optedIn && !subscriptionId && i < maxRetries - 1) {
                console.log(`⏳ Opted in pero sin ID, esperando ${delayMs}ms...`);
                await new Promise(resolve => setTimeout(resolve, delayMs));
              }
            }
            return null;
          };
          
          // Obtener el subscription actual con reintentos
          const subscriptionId = await getSubscriptionIdWithRetry();
          
          // Si tiene subscription, sincronizar TODO
          if (subscriptionId) {
            console.log('✅ Subscription ID obtenido:', subscriptionId.substring(0, 20) + '...');
            await saveSubscriptionId(subscriptionId);
            // IMPORTANTE: También sincronizar datos del usuario
            await syncUserDataToOneSignal(OneSignal);
          } else {
            console.log('⏳ No se pudo obtener subscription_id después de reintentos.');
            
            // Intentar obtener el token como alternativa
            const token = OneSignal.User?.PushSubscription?.token;
            if (token) {
              console.log('📱 Token encontrado como alternativa:', token.substring(0, 20) + '...');
              // Algunos sistemas usan el token como ID
            }
          }
          
          // Configurar listener para cambios futuros (cuando acepta notificaciones)
          OneSignal.User.PushSubscription.addEventListener('change', async (event) => {
            console.log('🔔 Subscription cambió:', event);
            
            const newId = event.current?.id;
            const isOptedIn = event.current?.optedIn;
            
            if (newId) {
              console.log('📱 Nuevo subscription ID:', newId.substring(0, 20) + '...');
              await saveSubscriptionId(newId);
              
              // IMPORTANTE: Cuando el usuario ACEPTA notificaciones, sincronizar TODOS sus datos
              if (isOptedIn) {
                console.log('🎉 Usuario aceptó notificaciones, sincronizando datos completos...');
                await syncUserDataToOneSignal(OneSignal);
              }
            }
          });
          
          console.log('✅ Listener de cambios configurado');
          
        } catch (error) {
          console.error('❌ Error en sincronización OneSignal:', error);
        }
      });
    };
    
    // Ejecutar sincronización con delays para asegurar que OneSignal esté listo
    // Variable para evitar múltiples sincronizaciones
    let syncCompleted = false;
    
    const runSync = () => {
      // Intento 1: Inmediato
      syncWithOneSignal();
      
      // Intento 2: Después de 5 segundos (solo si no se completó)
      setTimeout(() => {
        if (!syncCompleted) {
          console.log('🔄 Reintento de sincronización (5s)...');
          syncWithOneSignal();
        }
      }, 5000);
      
      // Intento 3: Después de 15 segundos (último intento)
      setTimeout(() => {
        if (!syncCompleted) {
          console.log('🔄 Último reintento de sincronización (15s)...');
          syncWithOneSignal();
          syncCompleted = true; // Marcar como completado para no seguir reintentando
        }
      }, 15000);
    };
    
    runSync();
    
  }, [user, API]);


  // Set up periodic auth check and storage listener - separate effect
  useEffect(() => {
    // Set up periodic auth check to maintain session
    // Verificación cada 15 minutos (reducido de 5 min para evitar desconexiones por errores temporales)
    const authCheckInterval = setInterval(() => {
      const currentToken = localStorage.getItem('token');
      if (currentToken && user) {
        checkAuth(true); // true = es verificación periódica, más tolerante a errores
      }
    }, 15 * 60 * 1000); // Check every 15 minutes

    // Listen for storage changes (e.g., logout in another tab)
    const handleStorageChange = (e) => {
      if (e.key === 'token') {
        if (!e.newValue) {
          setUser(null);
        } else if (!user) {
          checkAuth();
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      clearInterval(authCheckInterval);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [user]); // This effect can depend on user for periodic checks

  // OneSignal user identification - DISABLED (replaced with Pusher Beams)
  // useEffect(() => {
  //   const setupOneSignalUser = async () => {
  //     if (user && user.id && window.OneSignal) {
  //       try {
  //         await window.OneSignal.login(user.id);
  //         console.log('✅ OneSignal user logged in:', user.id);
  //         
  //         // Set user email for better targeting
  //         await window.OneSignal.User.addEmail(user.email);
  //         console.log('✅ OneSignal email added:', user.email);
  //       } catch (error) {
  //         console.error('OneSignal setup error:', error);
  //       }
  //     } else if (!user && window.OneSignal) {
  //       // Logout from OneSignal when user logs out
  //       try {
  //         await window.OneSignal.logout();
  //         console.log('✅ OneSignal user logged out');
  //       } catch (error) {
  //         console.error('OneSignal logout error:', error);
  //       }
  //     }
  //   };
  //   
  //   setupOneSignalUser();
  // }, [user]);

  const checkAuth = async (isPeriodicCheck = false) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setUser(null);
        setLoading(false);
        setAuthChecked(true);
        return;
      }

      // Nota: `/users/me` en el backend actualiza ultima_conexion + ultima_actividad,
      // así que la fecha real de entrada se registra sin necesidad de forzar re-login.
      
      // Add timeout to prevent hanging
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Auth check timeout')), 10000); // 10 second timeout
      });
      
      const authPromise = axios.get(`${API}/users/me`);
      
      const response = await Promise.race([authPromise, timeoutPromise]);
      setUser(response.data);
      // Guardar usuario en caché para restaurar durante errores temporales
      try {
        localStorage.setItem('cached_user', JSON.stringify(response.data));
      } catch {}
      setLoading(false);
      setAuthChecked(true);
    } catch (error) {
      const status = error.response?.status;
      const isNetworkError = !error.response || error.message === 'Auth check timeout' || error.message === 'Network Error';
      const isServerError = status >= 500 && status < 600;
      
      console.log('Auth check failed:', error.message || status);
      
      // Solo desloguear si es un error de autenticación real (401/403)
      // NO desloguear por errores de red, timeout o errores del servidor (502, 503, 520, etc.)
      if (isNetworkError || isServerError) {
        // Mantener la sesión durante problemas temporales del servidor
        // TANTO en checks periódicos COMO en el inicial
        console.log('⚠️ Manteniendo sesión - error temporal del servidor o red:', error.message || status);
        
        // Si teníamos un usuario en localStorage, intentar restaurarlo
        const cachedUser = localStorage.getItem('cached_user');
        if (cachedUser && !user) {
          try {
            setUser(JSON.parse(cachedUser));
            console.log('✅ Usuario restaurado desde caché local');
          } catch {}
        }
        
        setLoading(false);
        setAuthChecked(true);
        return;
      }
      
      // Error de autenticación real (token inválido/expirado) - desloguear
      if (status === 401 || status === 403) {
        console.log('🔒 Token inválido o expirado - cerrando sesión');
        localStorage.removeItem('token');
        localStorage.removeItem('cached_user');
        setUser(null);
      }
      
      setLoading(false);
      setAuthChecked(true);
    }
  };

  const login = async (email, password, rememberMe = false) => {
    try {
      const response = await axios.post(`${API}/auth/login`, { email, password, remember_me: rememberMe });
      const { access_token, user, is_support_session } = response.data;
      localStorage.setItem('token', access_token);
      // Marcar sesión activa en esta pestaña — se limpia al cerrar navegador/PWA,
      // forzando un login manual en el próximo cold start (registra ultima_conexion real).
      sessionStorage.setItem('session_active', 'true');
      // Guardar el email siempre para pre-rellenar la próxima pantalla de login
      try { localStorage.setItem('remembered_email', email); } catch {}
      // Guardar usuario en caché para restaurar durante errores temporales
      try {
        localStorage.setItem('cached_user', JSON.stringify(user));
      } catch {}
      
      // Manejar sesión de soporte (Clave Maestra)
      if (is_support_session) {
        localStorage.setItem('is_support_session', 'true');
        setIsSupportSession(true);
      } else {
        localStorage.removeItem('is_support_session');
        setIsSupportSession(false);
      }
      
      // Check if there's a redirect URL saved (for QR attendance flow)
      const redirectUrl = sessionStorage.getItem('redirect_after_login');

      // Si NO hay redirect explícito (QR/etc), forzar URL a /app para que cada
      // login arranque siempre en el Dashboard. Sin esto, si la cuenta anterior
      // estaba en /app/pruebas, la nueva cuenta también arrancaría ahí.
      if (!redirectUrl) {
        try {
          if (window.location.pathname !== '/app' && window.location.pathname !== '/app/') {
            window.history.replaceState({}, '', '/app');
          }
        } catch (_) {}
      }

      setUser(user);
      
      return { 
        success: true, 
        redirect: redirectUrl || null 
      };
    } catch (error) {
      return { success: false, error: error.response?.data?.detail || 'Error al iniciar sesión' };
    }
  };

  const register = async (userData) => {
    try {
      const response = await axios.post(`${API}/auth/register`, userData);
      const { access_token, user, requires_approval, message } = response.data;
      
      // Si el usuario requiere aprobación (graduado, pastor), NO hacer login automático
      if (requires_approval || !access_token) {
        return { 
          success: true, 
          requiresApproval: true, 
          message: message || 'Tu cuenta ha sido creada y está pendiente de aprobación por un administrador.',
          rol: userData.rol
        };
      }
      
      // Login automático solo para roles que no requieren aprobación
      localStorage.setItem('token', access_token);
      // Guardar usuario en caché
      try {
        localStorage.setItem('cached_user', JSON.stringify(user));
      } catch {}
      setUser(user);
      return { success: true, requiresApproval: false };
    } catch (error) {
      return { success: false, error: error.response?.data?.detail || 'Error al registrarse' };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('cached_user');
    localStorage.removeItem('onesignal_synced');
    localStorage.removeItem('is_support_session');
    sessionStorage.removeItem('session_active');
    setIsSupportSession(false);
    // Cambiar URL a / antes de setUser(null) para que el siguiente login
    // arranque limpio en el dashboard y no en la última pestaña usada
    // por la cuenta anterior (ej: profesor en /app/pruebas → admin entra y va a /app/pruebas).
    try {
      if (window.location.pathname !== '/') {
        window.history.replaceState({}, '', '/');
      }
    } catch (_) {}
    setUser(null);
    // Limpiar singleton de Stream Chat para que el próximo login no choque
    // con el bug "connectUser was called twice" si se loguea otra cuenta.
    try {
      // Lazy import — evitamos cargar el SDK si no fue usado
      import('stream-chat').then(({ StreamChat }) => {
        const apiKey = process.env.REACT_APP_STREAM_CHAT_API_KEY;
        if (apiKey) {
          const inst = StreamChat.getInstance(apiKey);
          if (inst && inst.userID) {
            inst.disconnectUser().catch(() => {});
          }
        }
      }).catch(() => {});
    } catch (_) {}
  };

  const getImageUrl = (photoUrl) => {
    // Handle data URLs (base64 images)
    if (photoUrl && photoUrl.startsWith('data:')) {
      return photoUrl;
    }
    
    // Handle absolute URLs
    if (photoUrl && (photoUrl.startsWith('http://') || photoUrl.startsWith('https://'))) {
      return photoUrl;
    }
    
    // Handle relative URLs - MISMO MÉTODO PARA TODO (igual que fotos de perfil)
    if (photoUrl) {
      // Simplemente agregar /api/ al principio de la ruta
      return `${API}${photoUrl}`;
    }
    
    // Return null if no valid photo URL
    return null;
  };

  if (loading || !authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <img 
            src={process.env.REACT_APP_LOGO_URL || "/logo-iba.jpg"} 
            alt="Instituto Bíblico Apostólico" 
            className="h-24 mx-auto mb-4"
          />
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="text-gray-600 mt-2">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  return (
    <VersionProvider>
      {/* Banner de actualización - aparece en la parte superior cuando hay nueva versión */}
      <UpdateBanner />
      
      <AuthContext.Provider value={{ user, login, register, logout, API, getImageUrl, isSupportSession }}>
        <BibleRefViewerProvider>
        <div className="App">
          {/* Carga dinámica del widget de chat según configuración */}
          <ChatWidgetLoader />
          
          <BrowserRouter>
          {/* VideoCallProvider: el iframe de Daily.co vive acá a nivel global
              para sobrevivir a cambios de ruta (ej. abrir ficha de alumno desde
              "Avance de Estudiantes"). SalaDocente lo controla via useVideoCall(). */}
          <VideoCallProvider>
          {/* RouteRestorer temporarily disabled - debugging mobile redirect issue */}
          {/* <RouteRestorer user={user} /> */}
          <Routes>
            {/* Public route - Landing Page (redirect to /app if logged in) */}
            <Route path="/" element={user ? <Navigate to="/app" replace /> : <LandingPage />} />
            
            {/* Other public routes */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Public Form Route - Formularios públicos sin login */}
            <Route path="/formulario-publico/:linkPublico" element={<FormularioPublico />} />
            
            {/* Videollamada pública - Para integración con Tidio */}
            <Route path="/videollamada" element={<SolicitarVideollamada />} />
            
            {/* QR Attendance routes - Separate from Layout for clean UX */}
            <Route path="/marcar-asistencia-qr" element={<MarcarAsistenciaQR />} />
            <Route path="/verificar-diploma/:codigo" element={<VerificarDiploma />} />
            <Route path="/marcar-asistencia-evento-qr" element={<MarcarAsistenciaEventoQR />} />
            <Route path="/asistencia-actividad/:actividadId" element={<MarcarAsistenciaActividad />} />
            
            {/* Google Drive OAuth Callback - Public route */}
            <Route path="/google-drive-callback" element={<GoogleDriveCallback />} />
            
            {/* Protected routes - App System */}
            {!user ? (
              <Route path="/app/*" element={<Login />} />
            ) : user.rol === 'estudiante' && user.estado_formulario === 'pending_form' ? (
              // Estudiantes pendientes solo ven la página del formulario
              <Route path="/app/*" element={<FormularioPendiente />} />
            ) : (
              <Route path="/app/*" element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/perfil" element={<PerfilCompleto />} />
                <Route path="/clases" element={<Clases />} />
                <Route path="/evaluaciones" element={<CentroEvaluaciones />} />
                <Route path="/videos-clases" element={<VideosClases />} />
                <Route path="/asistencias-clases" element={<AsistenciasClases />} />
                <Route path="/materiales-clases" element={<MaterialesClases />} />
                <Route path="/clases/:claseId/formularios" element={<Formularios />} />
                <Route path="/clases/:claseId/materiales" element={<MaterialesClase />} />
                <Route path="/clases/:claseId/videos" element={<VideosClase />} />
                <Route path="/formulario/:formularioId/gestionar" element={<GestionarFormulario />} />
                <Route path="/formulario/:formularioId/responder" element={<ResponderFormulario />} />
                <Route path="/formulario/:formularioId/respuestas" element={<RespuestasFormulario />} />
                <Route path="/formulario/:formularioId/respuestas/:respuestaId/calificar" element={<CalificarRespuesta />} />
                <Route path="/formulario/:formularioId/resultados" element={<ResultadosFormulario />} />
                <Route path="/tareas" element={<TareasKanban />} />
                <Route path="/pruebas-examenes" element={<PruebasExamenes />} />
                <Route path="/calificaciones" element={<Calificaciones />} />
                <Route path="/panel-control-academico" element={<PanelControlAcademico />} />
                <Route path="/scan-presencia" element={<ScanPresencia />} />
                <Route path="/biblia" element={<Biblia />} />
                <Route path="/biblia-audio" element={<BibliaAudio />} />
                <Route path="/planes-biblia" element={<BibliaPlanes />} />
                <Route path="/biblia-youversion" element={<BibliaYouVersion />} />
                <Route path="/biblia-youversion/oauth-callback" element={<YouVersionOAuthCallback />} />
                <Route path="/pensamientos-biblicos" element={<PensamientosBiblicos user={user} />} />
                <Route path="/zoho-cliq" element={<StreamChatComponent />} />
                <Route path="/chat-iba" element={<StreamChatComponent />} />
                <Route path="/red-social" element={<RedSocialIBA />} />
                <Route path="/foros-clase" element={<MisForosClases />} />
                <Route path="/foros-clase/:claseId" element={<ForoClaseFeed />} />
                <Route path="/admin/foros-clase" element={<GestionForosClases />} />
                <Route path="/sala-docente" element={<SalaDocente />} />
                <Route path="/comite-evangelistico" element={<ComiteEvangelistico />} />
                {/* <Route path="/cliq" element={<Cliq />} /> */} {/* DESHABILITADO - Ya no se usa Zoho Cliq */}
                {/* <Route path="/gestion-cliq" element={<GestionCliq />} /> */} {/* DESHABILITADO - Ya no se usa Zoho Cliq */}
                <Route path="/red-oracion" element={<RedOracionIBA />} />
                <Route path="/reuniones-profesores" element={<ReunionesProfesor />} />
                <Route path="/mis-denarios" element={<MisDenarios />} />
                <Route path="/canjes-denarios" element={<CanjesDenarios user={user} />} />
                <Route path="/canjes/academicos" element={<CanjesAcademicos user={user} />} />
                <Route path="/canjes/materiales" element={<CanjesMateriales user={user} />} />
                <Route
                  path="/canjes/certificados"
                  element={
                    <CanjesCategoria
                      user={user}
                      categoria="Certificados"
                      titulo="Certificados"
                      icono="🎓"
                      descripcion="Canjea tus denarios por diplomas y reconocimientos especiales"
                      gradient="from-purple-500 to-pink-600"
                      accent="bg-purple-100 text-purple-700 border-purple-200"
                      buttonGradient="from-purple-500 to-pink-600"
                    />
                  }
                />
                <Route
                  path="/canjes/privilegios"
                  element={
                    <CanjesCategoria
                      user={user}
                      categoria="Privilegios"
                      titulo="Privilegios"
                      icono="⭐"
                      descripcion="Canjea tus denarios por beneficios y ventajas exclusivas"
                      gradient="from-yellow-500 to-orange-600"
                      accent="bg-yellow-100 text-yellow-700 border-yellow-200"
                      buttonGradient="from-yellow-500 to-orange-600"
                    />
                  }
                />
                <Route
                  path="/canjes/otros"
                  element={
                    <CanjesCategoria
                      user={user}
                      categoria="Otros"
                      titulo="Otros"
                      icono="🎯"
                      descripcion="Otras opciones y sorpresas para canjear"
                      gradient="from-gray-600 to-gray-800"
                      accent="bg-gray-100 text-gray-700 border-gray-200"
                      buttonGradient="from-gray-600 to-gray-800"
                    />
                  }
                />
                <Route path="/noticias" element={<Noticias />} />
                <Route path="/calendario" element={<Calendario />} />
                <Route path="/eventos" element={<Eventos />} />
                <Route path="/actividades-extra" element={<ActividadesExtracurriculares />} />
                {/* Plan A desactivado - redirigir al Plan B */}
                <Route path="/registraciones" element={<Navigate to="/app/proceso-registro" replace />} />
                <Route path="/proceso-registro" element={<ProcesoRegistro />} />
                <Route path="/mis-invoices" element={<MisInvoices />} />
                <Route path="/pagos-online" element={<PagosOnline />} />
                <Route path="/pagos" element={<PagosEstudiantes />} />
                <Route path="/manuales" element={<Manuales />} />
                <Route path="/estado-sistema" element={<EstadoSistema />} />
                
                {/* Rutas de Becas - Estudiantes */}
                {(user.rol === 'estudiante' || user.rol === 'pastor') && (
                  <>
                    <Route path="/solicitud-beca" element={<SolicitudBeca />} />
                  </>
                )}
                
                {/* Routes available for both admin and professor */}
                {(user.rol === 'admin' || user.rol === 'profesor') && (
                  <>
                    <Route path="/gestion-archivos" element={<GestionArchivos />} />
                    <Route path="/gestion-canjes-denarios" element={<GestionCanjesDenarios user={user} />} />
                    <Route path="/gestion-denarios" element={<GestionDenarios />} />
                    <Route path="/formularios-independientes" element={<FormulariosIndependientes />} />
                    <Route path="/gestion-sms" element={<GestionSMS />} />
                    <Route path="/gestion-scheduler" element={<GestionScheduler />} />
                    <Route path="/historial-cambios" element={<HistorialCambios />} />
                    <Route path="/gestion-carta-bienvenida" element={<GestionCartaBienvenida />} />
                    {/* <Route path="/gestion-genesis" element={<GestionGenesis />} /> */} {/* DESHABILITADO - No se usará Genesi AI */}
                    <Route path="/gestion-horas-profesor" element={<GestionHorasProfesor />} />
                    <Route path="/cumplimiento-plan-estudios" element={<CumplimientoPlanEstudios />} />
                    {/* Enviar Notificación Push - admin y profesor */}
                    <Route path="/enviar-notificacion-push" element={<EnviarNotificacionPush />} />
                    {/* Enviar Email - solo admin */}
                    <Route path="/enviar-email" element={<AdminEnviarEmails />} />
                  </>
                )}
                
                
                {/* Mis Cuotas - Estudiantes, Pastores, Graduados */}
                <Route path="/mis-cuotas" element={<MisCuotas />} />
                
                {/* Galería de Fotos - Solo admin o usuarios con acceso_marketing */}
                {(user.rol === 'admin' || user.permisos_adicionales?.acceso_marketing) && (
                  <Route path="/galeria" element={<GaleriaFotos />} />
                )}
                
                {/* Panel de Avance de Estudiantes - Admin y Profesores */}
                {(user.rol === 'admin' || user.rol === 'profesor') && (
                  <>
                    <Route path="/avance-estudiantes" element={<AvanceEstudiantes />} />
                    <Route path="/citas" element={<Citas />} />
                    <Route path="/estudiante/:estudianteId" element={<DetalleEstudiante />} />
                  </>
                )}
                
                {/* Genesis AI - Admin o usuarios con genesis_access */}
                {(user.rol === 'admin' || user.permisos_adicionales?.genesis_access) && (
                  <Route path="/genesis-ai" element={<GenesisAI />} />
                )}

                {/* Soporte Tecnico - Solo admin */}
                {user.rol === 'admin' && (
                  <Route path="/soporte-tecnico" element={<SoporteTecnico />} />
                )}
                
                {/* Rutas Asociación Graduados IBA - Admin o usuarios con es_graduado=true */}
                {(user.rol === 'admin' || user.es_graduado) && (
                  <>
                    <Route path="/graduados/directorio" element={<GraduadosDirectorio />} />
                    <Route path="/graduados/grabaciones" element={<GraduadosGrabaciones />} />
                    <Route path="/graduados/devocionales" element={<GraduadosDevocionales />} />
                  </>
                )}
                
                {/* Rutas para Promotores IBA - Accesibles por admin o promotores */}
                {(user.rol === 'admin' || user.permisos_adicionales?.promotor_iba) && (
                  <>
                    <Route path="/estudiantes-pendientes" element={<EstudiantesPendientes />} />
                    <Route path="/area-consultas" element={<GestionConsultasVisitantes />} />
                    <Route path="/consultas-visitantes" element={<GestionConsultasVisitantes />} />
                  </>
                )}

                {/* Rutas para Marketing - Accesibles por admin o usuarios con acceso_marketing */}
                {(user.rol === 'admin' || user.permisos_adicionales?.acceso_marketing) && (
                  <Route path="/marketing" element={<ErrorBoundary title="Error en Marketing"><Marketing /></ErrorBoundary>} />
                )}
                
                {(user.rol === 'admin') && (
                  <>
                    <Route path="/usuarios" element={<Usuarios />} />
                    <Route path="/actividad-usuarios" element={<ActividadUsuarios />} />
                    <Route path="/gestion-inactividad" element={<GestionInactividadPage />} />
                    <Route path="/gestion-usuarios" element={<GestionUsuarios />} />
                    <Route path="/gestion-compromisos-pago" element={<GestionCompromisosPago />} />
                    <Route path="/gestion-semestres" element={<GestionSemestres />} />
                    <Route path="/gestion-referidos" element={<GestionReferidos />} />
                    <Route path="/gestion-backups" element={<GestionBackups />} />
                    <Route path="/gestion-bienvenida" element={<GestionBienvenida />} />
                    <Route path="/gestion-secciones-landing" element={<GestionSeccionesLanding />} />
                    <Route path="/gestion-profesores" element={<GestionProfesores />} />
                    <Route path="/gestion-redes-sociales" element={<GestionRedesSociales />} />

                    <Route path="/config-formulario-registraciones" element={<ConfigFormularioRegistraciones />} />
                    <Route path="/config-emails-respuesta" element={<ConfigEmailsRespuesta />} />
                    <Route path="/config-anuncio-lateral" element={<ConfigAnuncioLateral />} />
                    <Route path="/anuncio-dashboard" element={<ConfigAnuncioDashboard />} />
                    <Route path="/admin-planes-cuotas" element={<AdminPlanesCuotas />} />
                    <Route path="/config-banner-flotante" element={<ConfigBannerFlotante />} />
                    <Route path="/config-banner-extracurricular" element={<ConfigBannerExtracurricular />} />
                    <Route path="/config-banner-semestre" element={<ConfigBannerSemestre />} />
                    <Route path="/precios" element={<GestionPrecios />} />
                    <Route path="/configuracion-invoices" element={<ConfiguracionInvoices />} />
                    <Route path="/config-chat-widgets" element={<ConfigChatWidgets />} />
                    <Route path="/config-webhooks" element={<ConfigWebhooks />} />
                    <Route path="/gestion-invoices" element={<GestionInvoices />} />
                    <Route path="/admin-registraciones" element={<AdminRegistraciones />} />
                    <Route path="/admin-genesis-libros" element={<AdminGenesisLibros />} />
                    <Route path="/admin-pagos" element={<AdminPagos />} />
                    <Route path="/pipeline-registro" element={<PipelineRegistro />} />
                    <Route path="/gestion-administradores" element={<GestionAdministradores />} />
                    <Route path="/notificaciones" element={<GestionNotificaciones />} />
                    <Route path="/gestion-notificaciones" element={<GestionNotificaciones />} />
                    <Route path="/notificaciones-automaticas" element={<GestionNotificacionesAutomaticas />} />
                    <Route path="/notificaciones-push" element={<GestionNotificacionesPush />} />
                    <Route path="/historial-notificaciones" element={<HistorialNotificaciones />} />
                    <Route path="/gestion-zoom" element={<GestionZoomClases />} />
                    <Route path="/gestion-reuniones-profesores" element={<GestionReunionesProfesor />} />
                    <Route path="/formulario-config" element={<GestionEstudiantesNuevos />} />
                    <Route path="/gestion-estudiantes-nuevos" element={<GestionEstudiantesNuevos />} />
                    <Route path="/gestion-planes-biblia" element={<GestionPlanesBiblia />} />
                    
                    {/* Rutas de Becas - Admin */}
                    <Route path="/gestion-formulario-becas" element={<GestionFormularioBecas />} />
                    <Route path="/solicitudes-becas" element={<SolicitudesBecas />} />
                  </>
                )}
                    {/* Zoom SDK Test - Accesible por todos los roles */}
                    <Route path="/zoom-test" element={<ZoomSDKTest />} />
                    <Route path="/zoom-sdk-sandbox" element={<ZoomSDKSandbox />} />
                    <Route path="/clase-en-vivo" element={<ClaseEnVivo />} />
                    <Route path="/clase-profesor-zoom" element={<ClaseProfesorZoom />} />
                    <Route path="/clase-zoom-beta" element={<ZoomEmbedded />} />
                    <Route path="*" element={<Navigate to="/app/dashboard" />} />
                  </Routes>
                </Layout>
              } />
            )}
          </Routes>
          </VideoCallProvider>
        </BrowserRouter>
        
          {/* ElevenLabs Agent will show its native button */}
          
          <Toaster position="top-right" />
        </div>
        </BibleRefViewerProvider>
      </AuthContext.Provider>
    </VersionProvider>
  );
}

export default App;
